// extracted by mini-css-extract-plugin
module.exports = {"MenuOverlay":"styles_MenuOverlay__TshbT","level-1":"styles_level-1__s6Lb1","level-2":"styles_level-2__KQ_gr","fadeIn":"styles_fadeIn__9jaw5","fadeOut":"styles_fadeOut__5517h"};